// extracted by mini-css-extract-plugin
module.exports = {"name":"styles_name__Ur7JM"};